export default {
  header: {
    title: 'Agir sur votre patrimoine :',
  },
  selfCare: {
    label: 'Prendre rendez-vous',
  },
  bannerTitles: {
    fast_circuit: 'Effectuer une opération',
    inheritance: 'Transmettre votre patrimoine',
    patrimonial_growth: 'Développer votre patrimoine',
  },
  cards: {
    buttonLabel: {
      isNotValid: 'Mettre à jour',
      isNotValidV2: 'Actualiser',
      isValid: 'Modifier',
    },
    label: {
      isNotValid: 'Une mise à jour est nécessaire avant de continuer',
      isValid: 'mise à jour effectuée',
    },
  },
  yourSituation: {
    card: {
      title: 'Votre situation',
    },
    container: {
      title: 'Votre profil',
    },
    bottomButton: {
      label: 'Actualiser vos informations personnelles',
    },
  },
  yourBudget: {
    card: {
      title: 'Votre budget',
    },
    container: {
      subtitle: 'Moyenne des 6 derniers mois',
    },
    bottomButton: {
      label: 'Actualiser votre budget',
    },
    legend: {
      assets: {
        title: 'Revenus',
      },
      charges: {
        title: 'Charges',
      },
    },
  },
  yourPatrimony: {
    card: {
      title: 'Votre patrimoine',
    },
    container: {
      title: 'Visualisez votre patrimoine',
    },
    bottomButton: {
      label: 'Actualiser votre patrimoine',
    },
    dropdown: {
      brutNet: 'Comparatif: patrimoine brut/net',
      brut: 'Votre patrimoine brut',
      net: 'Votre patrimoine net',
    },
  },
  investorProfile: {
    container: {
      subtitle: 'Votre profil investisseur',
    },
    bottomButton: {
      label: 'Mettre à jour votre qualification investisseur',
    },
    button: {
      label: 'En savoir plus',
    },
  },
  dml: {
    button: {
      label: 'Développez votre patrimoine',
    },
  },
  journey: {
    transmission: {
      title: 'Votre transmission',
      subtitle: 'Préparer votre transmission',
      lockedSubtitle: 'Le parcours Transmission n\'est pas encore disponible',
      lockedDescription: 'Ce parcours vous permet de simuler les montants de droit de succession que vos ayants droits seraient amenés à payer.',
      unlockedDescription: '',
    },
    taxes: {
      title: 'Votre fiscalité',
      subtitle: 'Maîtriser votre fiscalité',
      lockedSubtitle: 'Le parcours fiscalité n\'est pas encore disponible',
      lockedDescription: 'Ce parcours vous permet de découvrir les leviers à votre disposition pour optimiser votre fiscalité',
      unlockedDescription: '',
    },
    protection: {
      title: 'Protection de vos proches',
      subtitle: 'Protéger vos proches',
      lockedSubtitle: 'Le parcours Protection n\'est pas encore disponible',
      lockedDescription: 'Ce parcours vous permet de découvrir les leviers permettant de couvrir les besoins de vos proches en cas de décès',
      unlockedDescription: 'Le montant de vos capitaux versés en cas de décès s\'élève à {totalCoverageInAmount} soit {totalCoverageInPercentage} de vos revenus annuels actuels. Il est possible d\'optimiser ce montant pour protéger vos proches',
      headingSubtitle: 'Vos capitaux prévoyance'
    },
    retirement: {
      title: 'Votre retraite',
      subtitle: 'Préparer votre retraite',
      lockedSubtitle: 'Le parcours Retraite n\'est pas encore disponible',
      lockedDescription: 'Ce parcours vous permet de découvrir les leviers à votre disposition pour préparer votre retraite',
      unlockedDescription: 'Le montant estimé de vos revenus à la retraite est de {retirement} soit {retirementRate} de vos revenus imposables déclarés. Différentes solutions existent pour vous aider à améliorer ce revenu.',
      headingSubtitle: 'Votre retraite'
    },
    dmp: {
      lockedSubtitle: 'Parcours diversification',
      lockedDescription: 'Le parcours est momentanément indisponible...',
    },
  },
}
